// extracted by mini-css-extract-plugin
export default {"wrapper":"ScannerComponent_wrapper__iUb5m","reader":"ScannerComponent_reader__UUc1v"};